import React from 'react';
import { Box, Typography } from '@mui/material';
import { Markdown } from '@qwickapps/react-framework';
import { useDocument } from '../contexts/DocumentContext';

export const PrintView: React.FC = () => {
  const { content, typographyStyle } = useDocument();

  const typographyStyles = {
    fontFamily: typographyStyle.fontFamily,
    fontSize: `${typographyStyle.fontSize}px`,
    lineHeight: typographyStyle.lineHeight,
    '& > *:first-of-type': {
      marginTop: '0 !important',
    },
    '& p': {
      marginTop: 0,
      marginBottom: `${typographyStyle.paragraphSpacing}em`,
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      marginTop: `${typographyStyle.headingTopMargin}em`,
      marginBottom: `${typographyStyle.headingBottomMargin}em`,
    },
    '& h1': {
      fontSize: `${typographyStyle.fontSize * typographyStyle.headingScale * 2}px`,
      marginTop: `${typographyStyle.sectionSpacing}em`,
    },
    '& h1:first-of-type': {
      marginTop: '0 !important',
    },
    '& h2': {
      fontSize: `${typographyStyle.fontSize * typographyStyle.headingScale * 1.5}px`,
      marginTop: `${typographyStyle.sectionSpacing * 0.8}em`,
    },
    '& h3': {
      fontSize: `${typographyStyle.fontSize * typographyStyle.headingScale * 1.25}px`,
    },
    '& h4, & h5, & h6': {
      fontSize: `${typographyStyle.fontSize * typographyStyle.headingScale}px`,
    },
  };

  return (
    <Box sx={{ backgroundColor: 'background.paper', padding: '20mm' }}>
      {content ? (
        <Markdown sanitize={true} sx={typographyStyles}>
          {content}
        </Markdown>
      ) : (
        <Typography color="text.secondary" fontStyle="italic">
          No content to print
        </Typography>
      )}
    </Box>
  );
};
